import React, {useState, useEffect, useRef} from "react";
import Layout from "./layout.js"; 
import Breadcrumbs from "../component/Breadcrumbs.js";
import ButtonPrimary from "../component/ButtonPrimary.js";
import indiaVector from "../assets/images/india.svg";
import usaVector from "../assets/images/usa.svg";
import ausVector from "../assets/images/australia.png";
import linkedinIcon from "../assets/images/linkedin.png";
import xIcon from "../assets/images/twitter.png";
import fbIcon from "../assets/images/facebook.png";
import youtubeIcon from "../assets/images/youtube.png";
import instaIcon from "../assets/images/instagram.png";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {decode} from 'html-entities';
import { alertifyMessage, apiCall, emailRegex, manageNetworkError } from "../assets/js/common.js";
import ReCaptchaV2 from "../component/ReCaptchaV2.js";
import * as Constants from '../config/constants.js';

export default function ContactUs({pageName}) {

  const { t } = useTranslation(["translation", "errorMessage"]);

  const canonicalUrl = `${Constants.SITE_URL}/contact/`;

  const seoData = {
    seo_title: pageName,
    seo_description:
      "Contact IBC Consultants for consulting services, partnerships, or career opportunities. Reach us via email or submit your requirements through our contact form.",
    seo_keywords:
      "scaling consulting business, boutique consulting firms, independent consultants, consulting execution partner, consulting partnerships, white label consulting services, consulting outsourcing, consulting staff augmentation, offshore research team for consulting, consulting PMO services, hybrid delivery model consulting, consulting capacity management, consulting managed services",
    canonical_url: canonicalUrl,
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  const recaptchaRef = useRef(null);

  const onSubmit = async (data) => {
    const token = window.grecaptcha.getResponse();

    if (!token) {
      alertifyMessage("error", "Please verify that you are not a robot.");
      return;
    }

    const payload = {
      ...data,
      'g-recaptcha-response': token,
    };
    
    var submitContact = await apiCall('post', 'submitContact', payload);
    
    if (submitContact.status !== false) {
      if (submitContact.data.status_code === 1) {
        alertifyMessage("success", submitContact.data.message);
        reset();
        window.grecaptcha.reset();
      } else {
        alertifyMessage("error", submitContact.data.message);
      }
    } else {
      manageNetworkError(submitContact);
    }
  };

  const [settingInfo , setSettingInfo] = useState([]);

  const getSettingInfo = async () => {
    const getSettingData = await apiCall('get', Constants.SETTING_URL, null, false);
    if(getSettingData.status !== false){
      if(getSettingData?.data?.data){
        setSettingInfo(getSettingData.data.data?.recordInfo);
      }
    } else {
      manageNetworkError(getSettingData);
    }
  }

  useEffect(() => {
    getSettingInfo(); 
  }, []);  

  return (
    <Layout pageName={pageName} seoData={seoData} pageUrl={canonicalUrl}>
      <Breadcrumbs title={pageName} text="Contact us for consulting delivery and workstream support" />

      <section className="contact-section border-bottom"> 
        <div className="container">
          <div className="inner-content">
            <div className="left-cnt">

              <div className="address-mdiv">
                <div className="address">
                  <div className="icon-div">
                    <img src={indiaVector} alt="India office" className="img-fluid icon" />
                  </div>
                  <div className="address-cnt">
                    <h5 className="country-title">INDIA</h5>
                    <ul className="address-list">
                      {settingInfo?.address && (
                        <li className="text"><address dangerouslySetInnerHTML={{__html: decode(settingInfo.address)}}></address></li>
                      )}
                      <li className="text">102, Soho, Kharadi, Pune - 412207</li>
                    </ul>
                  </div>
                </div>

                <div className="address">
                  <div className="icon-div">
                    <img src={usaVector} alt="USA office" className="img-fluid icon" />
                  </div>
                  <div className="address-cnt">
                    <h5 className="country-title">USA</h5>
                    <p className="text">10703 127th AVE NE, Kirkland, WA 98033-4728</p>
                  </div>
                </div>

                <div className="address">
                  <div className="icon-div">
                    <img src={ausVector} alt="Australia office" className="img-fluid icon" />
                  </div>
                  <div className="address-cnt">
                    <h5 className="country-title">Australia</h5>
                    <p className="text">Melbourne</p>
                  </div>
                </div>
              </div>

              {settingInfo?.email && (
                <div className="mail-div">
                  <h5 className="title">Mail Us On:</h5>
                  <Link to={"mailto:" + settingInfo.email} className="p-text mail-text">{settingInfo.email}</Link>
                </div>
              )}

              {(settingInfo?.facebook_link || settingInfo?.instagram_link || settingInfo?.twitter_link || settingInfo?.linkedin_link || settingInfo?.youtube_link) && (
                <div className="social-div">
                  <h5 className="title">Go Social:</h5>
                  <div className="contact-social">
  {settingInfo?.facebook_link && <Link to={settingInfo.facebook_link} target="_blank" rel="noopener noreferrer"><img src={fbIcon} alt="Facebook" className="icn-img" style={{width: "32px", height: "32px", objectFit: "contain"}} /></Link>}
  {settingInfo?.instagram_link && <Link to={settingInfo.instagram_link} target="_blank" rel="noopener noreferrer"><img src={instaIcon} alt="Instagram" className="icn-img" style={{width: "32px", height: "32px", objectFit: "contain"}} /></Link>}
  {settingInfo?.twitter_link && <Link to={settingInfo.twitter_link} target="_blank" rel="noopener noreferrer"><img src={xIcon} alt="X" className="icn-img" style={{width: "32px", height: "32px", objectFit: "contain"}} /></Link>}
  {settingInfo?.linkedin_link && <Link to={settingInfo.linkedin_link} target="_blank" rel="noopener noreferrer"><img src={linkedinIcon} alt="Linkedin" className="icn-img" style={{width: "32px", height: "32px", objectFit: "contain"}} /></Link>}
  {settingInfo?.youtube_link && <Link to={settingInfo.youtube_link} target="_blank" rel="noopener noreferrer"><img src={youtubeIcon} alt="Youtube" className="icn-img" style={{width: "32px", height: "32px", objectFit: "contain"}} /></Link>}
</div>
                </div>
              )}
            </div>

            <div className="right-cnt">
              <div className="contact-card">
                <div className="heading-div">
                  <h5 className="heading">Write To Us:</h5>
                  <p className="p-text">For partnerships or consulting inquiries please fill the form below:</p>
                </div>

                <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                  <div className="form-div">

                    <div className="form-group">
                      <input className="form-control" {...register("name", {required: true})} placeholder="Name*" />
                      {errors.name && (<span className="text-danger">{t('errorMessage:required-enter-name')}</span>)}
                    </div>

                    <div className="form-group">
                      <input className="form-control" {...register("email", {required: true, validate:(v)=>emailRegex(v,t('errorMessage:invalid-enter-field-validation',{module:t('email')}))})} placeholder="Email*" />
                      {errors.email && (<span className="text-danger">{errors.email.message}</span>)}
                    </div>

                    <div className="form-group">
                      <textarea className="form-control" {...register("detailed_requirements",{required:true})} placeholder="How can we help?*" />
                      {errors.detailed_requirements && (<span className="text-danger">{t('errorMessage:required-enter-detailed-requirements')}</span>)}
                    </div>

                    <ReCaptchaV2 ref={recaptchaRef} siteKey={Constants.RECAPTCHA_SITE_KEY} />

                    <ButtonPrimary buttonType="submit" title="Submit" />


                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
      </section>

    </Layout>
  );
}
